var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDanger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13435 12.5671L6.99464 3.37929C7.09172 3.1958 7.23699 3.04226 7.41482 2.93517C7.59265 2.82807 7.79631 2.77148 8.0039 2.77148C8.21149 2.77148 8.41515 2.82807 8.59298 2.93517C8.77081 3.04226 8.91608 3.1958 9.01317 3.37929L13.8735 12.5671C13.9647 12.7405 14.0094 12.9345 14.0034 13.1304C13.9973 13.3262 13.9406 13.5171 13.8388 13.6845C13.737 13.8519 13.5935 13.9901 13.4225 14.0855C13.2514 14.181 13.0585 14.2306 12.8626 14.2293H3.14307C2.94733 14.2302 2.75471 14.1804 2.58392 14.0847C2.41314 13.9891 2.27002 13.8509 2.16847 13.6835C2.06692 13.5162 2.01041 13.3255 2.00444 13.1298C1.99846 12.9342 2.04321 12.7403 2.13435 12.5671V12.5671Z",
    stroke: "#C01048",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00238 6.5918V9.67127",
    stroke: "#C01048",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07012 11.7734C8.07012 11.8111 8.03955 11.8417 8.00179 11.8417C7.96404 11.8417 7.93347 11.8111 7.93347 11.7734C7.93347 11.7357 7.96404 11.7051 8.00179 11.7051C8.03955 11.7051 8.07012 11.7357 8.07012 11.7734Z",
    fill: "#C01048",
    stroke: "#C01048",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.e7776e9a.svg";
export { ForwardRef as ReactComponent };